// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aQnv_.ui.dropdown.selection.active{border-bottom-left-radius:.2857rem!important;border-bottom-right-radius:.2857rem!important}.aQnv_.ui.dropdown.floating>.menu{border-top-width:1px!important;margin-bottom:.5em;max-height:none;min-width:100%;width:max-content}.aQnv_.ui.dropdown .lucide{color:#127d78}.aQnv_.ui.dropdown>.menu>.item.IFlAw{font-size:1.1rem;padding:.6rem 1rem!important}.aQnv_.ui.dropdown>.menu>.item.IFlAw>.description{font-weight:400;margin-left:3rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `aQnv_`,
	"option": `IFlAw`
};
module.exports = ___CSS_LOADER_EXPORT___;
